// Route Paths
export const DEFAULT = '/';
export const FEATURE_DISABLED = '/FeatureDisabled';

export const LOGIN = "/login";
export const SIGNIN_OIDC = "/signin-oidc";
export const SILENT_SIGNIN_OIDC = "/silent-signin-oidc";
export const SIGNOUT_CALLBACK_OIDC ="/signout-callback-oidc";
export const MAIN_PAGE="/main-page";